import * as types from '../types/visitorTypes';

const getInitialVisitorId = () => {
  try { return localStorage.getItem('visitorId'); } catch { return null; }
};

const getInitialVisitorCountryName = () => {
  try { return localStorage.getItem('visitorCountry'); } catch { return null; }
};

const getInitialVisitorCountryCode = () => {
  try {
    const c = localStorage.getItem('visitorCountryCode');
    return c && /^[A-Z]{2}$/i.test(String(c).trim()) ? String(c).trim().toUpperCase() : null;
  } catch {
    return null;
  }
};

const initialState = {
  visitors: [],
  currentVisitor: null,
  visitorId: getInitialVisitorId(),
  visitorCountry: getInitialVisitorCountryName(),
  visitorCountryCode: getInitialVisitorCountryCode(),
  loading: false,
  error: null,
};

const visitorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_VISITOR_REQUEST:
    case types.FETCH_VISITORS_REQUEST:
    case types.FETCH_VISITOR_REQUEST:
    case types.DELETE_VISITOR_REQUEST:
      return { ...state, loading: true, error: null };

    case types.CREATE_VISITOR_SUCCESS: {
      const visitorId = action.payload?.visitor?._id || action.payload?._id;
      if (visitorId) localStorage.setItem('visitorId', visitorId.toString());
      return {
        ...state,
        loading: false,
        currentVisitor: action.payload?.visitor || action.payload,
        visitorId: visitorId || state.visitorId,
        visitorCountry: action.payload?.visitor?.country || action.payload?.country || state.visitorCountry,
      };
    }

    case types.FETCH_VISITORS_SUCCESS:
      return { ...state, loading: false, visitors: action.payload };

    case types.FETCH_VISITOR_SUCCESS:
      return { ...state, loading: false, currentVisitor: action.payload, visitorId: action.payload?._id || state.visitorId };

    case types.DELETE_VISITOR_SUCCESS:
      return { ...state, loading: false, visitors: state.visitors.filter((v) => v._id !== action.payload) };

    case types.CREATE_VISITOR_FAILURE:
    case types.FETCH_VISITORS_FAILURE:
    case types.FETCH_VISITOR_FAILURE:
    case types.DELETE_VISITOR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.SET_VISITOR_COUNTRY: {
      const p = action.payload;
      if (p && typeof p === 'object') {
        const name = p.countryName ?? p.name;
        const rawCode = p.countryCode ?? p.code;
        const code =
          rawCode != null && String(rawCode).trim() !== ''
            ? String(rawCode).trim().toUpperCase()
            : null;
        const validCode = code && /^[A-Z]{2}$/.test(code) ? code : state.visitorCountryCode;
        return {
          ...state,
          ...(name != null && name !== '' ? { visitorCountry: name } : {}),
          ...(validCode ? { visitorCountryCode: validCode } : {}),
        };
      }
      if (typeof p === 'string' && p) {
        return { ...state, visitorCountry: p };
      }
      return state;
    }

    default:
      return state;
  }
};

export default visitorReducer;
